import { render } from "./EmailOnboardingDomain.vue?vue&type=template&id=79e3f0e7&scoped=true"
import script from "./EmailOnboardingDomain.vue?vue&type=script&lang=js"
export * from "./EmailOnboardingDomain.vue?vue&type=script&lang=js"

import "./EmailOnboardingDomain.vue?vue&type=style&index=0&id=79e3f0e7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e3f0e7"]])

export default __exports__